import Swiper from 'swiper';

var instaFeed = new Swiper(".js-feed", {
    speed: 500,
    simulateTouch: false,
    spaceBetween: 2,
    breakpoints: {
      0: {
        slidesPerView: 1,
        allowTouchMove: true,
        loop: true,
        loopedSlides: 2,
      },
      1024: {
        slidesPerView: 5,
        allowTouchMove: false,
        loop: false,
      },
    },
  });
